import * as ng from 'angular';
import * as _ from 'underscore';
import { StateService } from '@uirouter/angularjs';

import { IExpListDirectiveController } from '.';

interface DirectiveScope extends ng.IScope {
   slug:string;
   label:string;
   size:string;
   icon:string;
   id:number;
}

ng.module('e360').directive('expNode', expNodeDirectiveFactory);

expNodeDirectiveFactory.$inject = ['$state', '$compile',
   'experiencesService', 'experiencesNotices'
];
export function expNodeDirectiveFactory(
   $state:StateService, $compile:ng.ICompileService,
   experiencesService, experiencesNotices
) {
   return {
      restrict: 'E',
      require: '^expList',
      scope: {
         slug: '@',
         label: '@',
         size: '@',
         icon: '@',
         id: '<?'
      },
      link: expNodeDirectiveLinkFn
   };

   function expNodeDirectiveLinkFn(
      scope:DirectiveScope,
      element:ng.IAugmentedJQuery,
      attrs,
      controller:IExpListDirectiveController
   ) {
      init();

      scope.$watch(() => controller.data, (newData, oldData) => {
         if (newData !== oldData) {
            init();
         }
      });

      function init() {
         let active;

         if (scope.id) {
            active = _.find(controller.data, (e) => e.id === scope.id)
         } else {
            active = _.find(controller.data, (e) => e.typeDefinition.slug === scope.slug);
         }

         let expType = experiencesService.getTypeBySlug(scope.slug);
         let notices = new experiencesNotices(controller.data);
         let restricted = notices.getRestrictionsForType(expType);
         let notification = notices.getErrorsForType(expType);
         let warning = notices.getWarningsForType(expType);
         let tip = notices.getToolTipsForType(expType);

         if (active && active.isCustom) {
            restricted = { message: 'This is a custom campaign experience' };
         }

         element.attr('class', 'node node-' + scope.size);
         let wrapper = ng.element('<div class="node-wrapper"></div>');

         if (active && !restricted) {
            element
               .addClass(notification ? 'notification' : 'active')
               .click(function() {
                  $state.go('campaign.experienceEdit', {slug: scope.slug, id: active.id});
               });
         }

         if (!active && !restricted) {
            element
               .addClass(notification ? 'notification' : 'inactive')
               .click(function() {
                  $state.go('campaign.experienceEdit', {slug: scope.slug});
               });
         }

         let tooltip:string;
         if (restricted) {
            element.addClass('restricted');
            tooltip = restricted.message;

            //Make sure that restricted exp-nodes are not clickable
            element.unbind('click');
         } else if (notification) {
            element.addClass('notification');
            tooltip = notification.message;
         } else if (warning) {
            element.addClass('warning');
            tooltip = warning.message;
         } else if (tip) {
            tooltip = tip.message;
         }

         if (tooltip) {
            wrapper.attr({
               'uib-tooltip': tooltip,
               // keeps tooltip centered, off-center when appended to parent
               'tooltip-append-to-body': true,
               'tooltip-animation': null
            });
         }

         element.html('');

         let icon = ng.element('<div class="icon"></div>');

         if (restricted) {
            icon.addClass('icon-lock');
         } else {
            icon.addClass(scope.icon);
         }

         let type = active ? 'pencil' : 'plus';
         let label = active ? 'Manage' : 'Create';

         let hover = ng.element('<div class="hover"></div>');
         let hoverLabel = ng.element('<span class="name">' + label + '</span>');
         let hoverIcon = ng.element('<i class="fa fa-' + type + '"></i>');

         hover
            .append(hoverIcon)
            .append(hoverLabel);

         icon.append(hover);

         let field = ng.element(`<div class="field" title="${scope.label}"></div>`);
         let indicator = ng.element('<div class="indicator"><div class="dot"></div></div>');
         let name = ng.element(`<div class="name">${scope.label}</div>`);

         field
            .append(indicator)
            .append(name);

         if (!active && notification) {
            wrapper.append(ng.element('<div class="subtext">&ndash;REQUIRED&ndash;</div>'));
         }

         wrapper
            .append(icon)
            .append(field);

         element.append(wrapper);

         if (!restricted) {
            element.bind('mouseenter', function() {
               hover
                  .removeClass('fadeOut')
                  .addClass('animated fadeIn');

               field.addClass('hover');
            }).bind('mouseleave', function() {
               hover
                  .removeClass('fadeIn')
                  .addClass('animated fadeOut');

               field.removeClass('hover');
            });
         }

         $compile(element.contents())(scope);
      }
   }
}
